import { Button, Popover } from '@douyinfe/semi-ui';
import { IconGridView } from '@douyinfe/semi-icons';
import useToolboxStore from '@/components/Toolbox/store';
import './header.scss';

const ToolboxEntry = () => {
  const { toggleToolbox, hasSeenGuide, markGuideSeen, isGuideSuppressed } =
    useToolboxStore();

  const handleClick = () => {
    if (!hasSeenGuide) {
      markGuideSeen();
    }
    toggleToolbox();
  };

  const button = (
    <div
      className={`toolbox-entry ${!hasSeenGuide ? 'toolbox-entry--guide' : ''}`}
    >
      <Button
        theme='borderless'
        icon={
          <IconGridView
            className={!hasSeenGuide ? 'toolbox-entry__icon--pulse' : ''}
          />
        }
        onClick={handleClick}
      />
      {!hasSeenGuide && <span className='toolbox-entry__new'>NEW</span>}
    </div>
  );

  // 未看过引导且未被其他弹层抑制时，显示引导 Popover
  if (!hasSeenGuide && !isGuideSuppressed) {
    return (
      <Popover
        content={
          <div style={{ padding: '4px 8px' }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>智能工具箱</div>
            <div
              style={{
                color: 'var(--semi-color-text-2)',
                fontSize: 13,
                marginBottom: 6,
              }}
            >
              包含定价计算器等实用工具
            </div>
            <div
              style={{
                color: 'var(--semi-color-primary)',
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              👆 点击查看
            </div>
          </div>
        }
        position='bottom'
        trigger='custom'
        visible={true}
        showArrow
      >
        {button}
      </Popover>
    );
  }

  return button;
};

export default ToolboxEntry;
